import { Component, OnInit, Input, Attribute } from '@angular/core';
import { Noticia } from 'src/app/models/noticia.model';

@Component({
  selector: 'app-noticia',
  templateUrl: './noticia.component.html',
  styleUrls: ['./noticia.component.css']
})
export class NoticiaComponent implements OnInit {

  @Input('not') public noticia : Noticia

public id;
public titulo;
public mudanca;
public alvo;
public link;


  constructor()
  {

  }

  ngOnInit(): void {
    this.titulo = this.noticia.titulo;
    this.mudanca = this.noticia.mudanca;
    this.alvo = this.noticia.alvo;
    this.link = this.noticia.link;
    this.id = this.noticia.id;
  }

}
